import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Grid, Tab, Tabs } from '@mui/material';
import Page from '../../layout/Page';
import { DataTable } from '../../components/DataTable';
import ListPageActions from '../../components/ListPageActions';
import DownloadButton from '../../components/DownloadButton';
import SwitchCell from '../../components/SwitchCell';
import CustButton from '../../ui/CustButton';
import DateFilterCell from '../../components/DateFilterCell';
import DialogConfirm from '../../components/DialogConfirm';
import usePaginationV2 from '../../util/usePaginationV2';
import { Add, Settings, AddTask, RestartAlt, RefreshRounded } from '@mui/icons-material';
import WorkerPlannedJobservice from '../../service/MasterServices/WorkerPlannedJobservice';
import MenuListAction from '../../components/MenuListAction';
import FilterOptionEnum from '../../enum/FilterOptionEnum';
import SGKWorkerTipi from '../../enum/SGKWorkerTipi';
import { parseAndFormatDate, parseAndFormatDateTime } from '../../util/DateUtil';
import WorkerJobStatusEnum from '../../enum/WorkerJobStatus';
import WorkerTaskStatusEnum from '../../enum/WorkerTaskStatus';
import SGKWorkerTaskservice from '../../service/MasterServices/SGKWorkerTaskService';
import SGKWorkerMonitorservice from '../../service/MasterServices/SGKWorkerMonitorService';
import RobotMonitorTypeEnum from '../../enum/RobotMonitorType';
import MonitorStatusEnum from '../../enum/MonitorStatus';
import { YesNoTypeOptions } from '../../components/YesNoTypeOptions';
import SGKWorkerservice from '../../service/MasterServices/SGKWorkerService';
import WorkerStatusEnum from '../../enum/WorkerStatus';
import WorkerPlannedJobCrudDialog from './WorkerPlannedJobCrudDialog';
import SGKWorkerMonitorSummaryservice from '../../service/MasterServices/SGKWorkerMonitorSummaryService';
import MenuAction from '../../components/MenuAction ';
import useGlobal from '../../util/Global';
import { useSelector } from 'react-redux';
import DynamicOptions from '../../components/DynamicOptions';

const WorkerPlannedJobPage = ({ title }) => {
    const { t } = useGlobal();

    const [selectedItems, setSelectedItems] = useState([]);

    const [wokrerTasks, SetWorkerTasks] = useState([]);
    const [wokrerMonitors, SetWorkerMonitors] = useState([]);
    const [wokrers, SetWorkers] = useState([]);

    const [actionType, setActionType] = useState(null);
    const [loading, setLoading] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [crudTip, setCrudTip] = useState('');
    const [jobId, SetJobId] = useState(0);
    const [onCrudDialogOpen, setCrudDialogOpen] = useState(false);

    const [autoReset, setAutoReset] = useState(false);
    const { user } = useSelector(state => state.auth);

    const fetchData = async () => {
        taskDataList.setSearchData({ jobId: jobId });
        taskDataList.search([]);

        mointorDataList.setSearchData({ jobId: jobId });
        mointorDataList.search([]);

        workerDataList.search();

        workerSummaryDataList.setSearchData({ jobId: jobId });
        workerSummaryDataList.search();
    };

    useEffect(async () => {
        fetchData();
    }, [jobId]);

    useEffect(() => {
        if (!autoReset) return; // Exit if autoReset is false

        const intervalId = setInterval(fetchData, 15000);

        return () => clearInterval(intervalId); // Cleanup interval on unmount or autoReset change
    }, [autoReset, jobId]);



    const handleAction = async () => {
        setLoading(true);

        const actionMap = {
            Reset: {
                service: WorkerPlannedJobservice,
                method: 'bulkReset',
                data: () => Object.values(selectedItems),
                postAction: () => mainDataList.search(),
            },
            Set: {
                service: WorkerPlannedJobservice,
                method: 'bulkSet',
                data: () => Object.values(selectedItems),
                postAction: () => mainDataList.search(),
            },
            WorkerSet: {
                service: SGKWorkerservice,
                method: 'bulkSet',
                data: () => Object.values(wokrers),
                postAction: () => workerDataList.search(),
            },
            WorkerReset: {
                service: SGKWorkerservice,
                method: 'bulkReset',
                data: () => Object.values(wokrers),
                postAction: () => workerDataList.search(),
            },
            workerTaskSet: {
                service: SGKWorkerTaskservice,
                method: 'bulkSet',
                data: () => Object.values(wokrerTasks),
                postAction: () => taskDataList.search(),
            },
            WorkerTaskReset: {
                service: SGKWorkerTaskservice,
                method: 'bulkReset',
                data: () => Object.values(wokrerTasks),
                postAction: () => taskDataList.search(),
            },
            WorkerMonitorSet: {
                service: SGKWorkerMonitorservice,
                method: 'bulkSet',
                data: () => Object.values(wokrerMonitors),
                postAction: () => mointorDataList.search(),
            },
            WorkerMonitorReset: {
                service: SGKWorkerMonitorservice,
                method: 'bulkReset',
                data: () => Object.values(wokrerMonitors),
                postAction: () => mointorDataList.search(),
            },
            WorkerMonitorSetAll: {
                service: SGKWorkerMonitorservice,
                method: 'bulkSetJobOrWorker',
                data: () => jobId,
                postAction: () => mointorDataList.search(),
            },
            WorkerMonitorResetAll: {
                service: SGKWorkerMonitorservice,
                method: 'bulkResetJobOrWorker',
                data: () => jobId,
                postAction: () => mointorDataList.search(),
            },
        };

        try {
            const action = actionMap[actionType];

            if (!action) {
                console.warn(`Unknown action type: ${actionType}`);
                return;
            }

            const data = action.data();
            if (!data || (Array.isArray(data) && !data.length)) {
                console.warn('No valid items selected.');
                return;
            }

            const result = await action.service[action.method](data);
            if (result && action.postAction) {
                action.postAction(); // Dynamically call the service's search method
            }
        } catch (error) {
            console.error('Action failed:', error);
        } finally {
            setLoading(false);
            setOpenDialog(false);
        }
    };



    const columns = [
        {
            passItem: true,
            searchable: false,
            sortable: false,
            label: t('col.islemler'),
            execute: (item) => <MenuListAction menuItems={
                [
                    {
                        label: t('col.hareketler'),
                        icon: <Settings fontSize='small' style={{ color: '#DDD4FF' }} />,
                        action: () => {

                            SetJobId(item.id);
                            setSelectedTab(1);
                            //  setAutoReset(true);
                        }
                    },
                ]
            } />
        },
        {
            name: "id",
            label: t('col.id'),
            textAlign: "center"
        },
        {
            name: "tenantName",
            label: t('col.tenantName'),
            textAlign: "center",
            searchable: user.isMaster,
            selectOptions: <DynamicOptions serviceType="Tenant" />,
            searchType: 'select',
            searchField: "tenantId",
            orderByField: "tenantName",
        },
        {
            name: "tip",
            label: t('col.tip'),
            textAlign: "center",
            execute: (item) => SGKWorkerTipi[item],
            searchable: true,
            searchType: "select",
            selectOptions: <FilterOptionEnum enumObject={SGKWorkerTipi} />
        },
        {
            name: "calismaZamani",
            label: t('col.calismaZamani'),
            textAlign: "center",
            execute: (item) => parseAndFormatDateTime(item),
            searchable: true,
            searchType: "custom",
            searchComponent: DateFilterCell
        },
        {
            name: "status",
            label: t('col.status'),
            textAlign: "center",
            execute: (item) => WorkerJobStatusEnum[item],
            searchable: true,
            searchType: "select",
            selectOptions: <FilterOptionEnum enumObject={WorkerJobStatusEnum} />
        },
        {
            name: "priority",
            label: t('col.priority'),
            textAlign: "center"
        },
        {
            name: "parameter1",
            label: t('col.parameter1'),
            textAlign: "center"
        },
        {
            name: "parameter2",
            label: t('col.parameter2'),
            textAlign: "center"
        },
        /*{
            sortable: false,
            searchable: false,
            passItem: true,
            textAlign: 'Center',
            title: 'action',
            execute: (item) => (
                <>
                    <IconButton
                        onClick={() => handleOpenCrudDialog(item, 'Update')}
                        color='warning'
                        variant='contained'
                        title={t('rowActions.update')}
                        size='small'>
                        <Edit />
                    </IconButton>
                    <IconButton
                        onClick={() => openConfirmDialog(item)}
                        color='error'
                        variant='contained'
                        title={t('rowActions.delete')}
                        size='small'>
                        <Delete />
                    </IconButton>
                </>
            ),
        },*/


    ];

    const taskColumns = [
        {
            name: "workerId",
            label: t('col.workerNo'),
            textAlign: "center"
        },
        {
            name: "jobId",
            label: t('col.jobId'),
            textAlign: "center"
        },
        {
            name: "status",
            label: t('col.status'),
            textAlign: "center",
            execute: (item) => WorkerTaskStatusEnum[item],
            searchable: true,
            searchType: "select",
            selectOptions: <FilterOptionEnum enumObject={WorkerTaskStatusEnum} />
        },
        {
            name: "startDate",
            label: t('col.startDate'),
            textAlign: "center",
            execute: (item) => parseAndFormatDateTime(item),
            searchable: true,
            searchType: "custom",
            searchComponent: DateFilterCell
        },
        {
            name: "endDate",
            label: t('col.endDate'),
            textAlign: "center",
            execute: (item) => parseAndFormatDateTime(item),
            searchable: true,
            searchType: "custom",
            searchComponent: DateFilterCell
        },
    ];

    const monitorColumn = [
        {
            name: "tenantName",
            label: t('col.tenantName'),
            textAlign: "center"
        },
        {
            name: "monitorType",
            label: t('col.monitorType'),
            textAlign: "center",
            execute: (item) => RobotMonitorTypeEnum[item],
            searchable: true,
            searchType: "select",
            selectOptions: <FilterOptionEnum enumObject={RobotMonitorTypeEnum} />
        },
        {
            name: "jobId",
            label: t('col.jobId'),
            textAlign: "center"
        },
        {
            name: "calismaGunu",
            label: t('col.calismaGunu'),
            textAlign: "center",
            execute: (item) => parseAndFormatDateTime(item),
            searchable: true,
            searchType: "custom",
            searchComponent: DateFilterCell
        },
        {
            name: "subeKodu",
            label: t('col.subeKodu'),
            textAlign: "center"
        },
        {
            name: "workerNo",
            label: t('col.workerNo'),
            textAlign: "center"
        },
        {
            name: "status",
            label: t('col.status'),
            textAlign: "center",
            execute: (item) => MonitorStatusEnum[item],
            searchable: true,
            searchType: "select",
            selectOptions: <FilterOptionEnum enumObject={MonitorStatusEnum} />
        },
        {
            name: "completed",
            type: Boolean,
            label: t('col.completed'),
            textAlign: "center",
            passItem: true,
            searchable: true,
            searchType: "select",
            selectOptions: <YesNoTypeOptions />,
            execute: (item) =>
                <SwitchCell item={item}
                    checked={item.completed}

                />
        },
        {
            name: "startDate",
            label: t('col.startDate'),
            textAlign: "center",
            execute: (item) => parseAndFormatDateTime(item),
            searchable: true,
            searchType: "custom",
            searchComponent: DateFilterCell
        },
        {
            name: "endDate",
            label: t('col.endDate'),
            textAlign: "center",
            execute: (item) => parseAndFormatDateTime(item),
            searchable: true,
            searchType: "custom",
            searchComponent: DateFilterCell
        },
    ];

    const workerColumn = [
        {
            name: "workerNo",
            label: t('col.workerNo'),
            textAlign: "center"
        },
        {
            name: "tip",
            label: t('col.tip'),
            textAlign: "center"
        },
        {
            name: "status",
            label: t('col.status'),
            textAlign: "center",
            execute: (item) => WorkerStatusEnum[item],
            searchable: true,
            searchType: "select",
            selectOptions: <FilterOptionEnum enumObject={WorkerStatusEnum} />
        },
        {
            name: "tenantName",
            label: t('col.aktifTenant'),
            textAlign: "center",
            searchable: true,

        },
        {
            name: "aktifJobId",
            label: t('col.aktifJobId'),
            textAlign: "center"
        },
        {
            name: "aktifTaskId",
            label: t('col.aktifTaskId'),
            textAlign: "center"
        },
        {
            name: "startDate",
            label: t('col.startDate'),
            textAlign: "center",
            execute: (item) => parseAndFormatDateTime(item),
            searchable: true,
            searchType: "custom",
            searchComponent: DateFilterCell
        },
        {
            name: "endDate",
            label: t('col.endDate'),
            textAlign: "center",
            execute: (item) => parseAndFormatDateTime(item),
            searchable: true,
            searchType: "custom",
            searchComponent: DateFilterCell
        },
    ];

    const workerSummaryColumn = [
        {
            name: "workerNo",
            label: t('col.workerNo'),
            textAlign: "center"
        },
        {
            name: "completed",
            type: Boolean,
            label: t('col.completed'),
            textAlign: "center",
            passItem: true,
            searchable: true,
            searchType: "select",
            selectOptions: <YesNoTypeOptions />,
            execute: (item) =>
                <SwitchCell item={item}
                    checked={item.completed}

                />
        },
        {
            name: "status",
            label: t('col.status'),
            textAlign: "center",
            execute: (item) => MonitorStatusEnum[item],
            searchable: true,
            searchType: "select",
            selectOptions: <FilterOptionEnum enumObject={MonitorStatusEnum} />
        },
        {
            name: "counter",
            label: t('col.Counter'),
            textAlign: "right"
        },
    ];

    const taskDataList = usePaginationV2({
        service: SGKWorkerTaskservice,
        pageColumns: taskColumns,
        defaultSearchData: { id: jobId },

        defaultOrderBy: { name: "Id", type: "Desc" }
    });

    const mainDataList = usePaginationV2({
        service: WorkerPlannedJobservice,
        pageColumns: columns,
        defaultSearchData: { isMaster: user.isMaster },
        defaultOrderBy: { name: 'calismaZamani', type: 'Desc' },
    });

    const mointorDataList = usePaginationV2({
        service: SGKWorkerMonitorservice,
        pageColumns: monitorColumn,
        defaultSearchData: { id: jobId },
        defaultOrderBy: { name: "id", type: "Desc" }

    });

    const workerDataList = usePaginationV2({
        service: SGKWorkerservice,
        pageColumns: workerColumn,
        defaultSearchData: { isMaster: user.isMaster },
        defaultOrderBy: { name: "id", type: "Desc" }
    });

    const workerSummaryDataList = usePaginationV2({
        service: SGKWorkerMonitorSummaryservice,
        pageColumns: workerSummaryColumn,
        defaultSearchData: { jobId: jobId },
        defaultOrderBy: { name: "id", type: "Desc" }
    })





    const handleOpenCrudDialog = (data, tip) => {
        SetJobId(data);
        setCrudDialogOpen(true);
        setCrudTip(tip);
    };

    const handleClose = async () => {
        setCrudDialogOpen(false);
        await mainDataList.search([]);
    };

    const openConfirmDialog = (item) => {
        setActionType(item);
        setOpenDialog(true);
    };
    const closeConfirmDialog = () => setOpenDialog(false);

    const ActionButtons = () => (
        <ListPageActions
            left={
                <>
                    <CustButton
                        icon={Add}
                        onClick={() => handleOpenCrudDialog(null, 'Create')}
                        style={{ marginLeft: 10 }}
                        disabled={loading}
                    >
                        {title + ' ' + t('button.add')}
                    </CustButton>
                    <CustButton
                        icon={AddTask}
                        onClick={() => openConfirmDialog("Set")}
                        style={{ marginLeft: 10 }}
                        disabled={loading}  // Disable buttons when loading
                    >
                        {t("col.Set")}
                    </CustButton>
                    <CustButton
                        icon={RestartAlt}
                        onClick={() => openConfirmDialog("Reset")}
                        style={{ marginLeft: 10 }}
                        color="secondary"
                        disabled={loading}  // Disable buttons when loading
                    >
                        {t("col.ResetJob")}
                    </CustButton>
                </>
            }



        >
            <CustButton
                icon={RefreshRounded}
                onClick={() => { setAutoReset(!autoReset); }}
                style={{ marginLeft: 10 }}
                color={(autoReset ? "secondary" : "primary")}
                disabled={loading}  // Disable buttons when loading
            >
                {t((autoReset ? "col.StopRefesh" : "col.autoRefesh"))}
            </CustButton>
            <DownloadButton service={mainDataList} disabled={loading} />
        </ListPageActions>
    );

    const WorkTaskButtons = () => {
        return <ListPageActions
            left={
                <>
                    <CustButton
                        icon={AddTask}
                        onClick={() => openConfirmDialog("WorkerTaskSet")}
                        style={{ marginLeft: 10 }}
                        disabled={loading}  // Disable buttons when loading
                    >
                        {t("col.Set")}
                    </CustButton>
                    <CustButton
                        icon={RestartAlt}
                        onClick={() => openConfirmDialog("WorkerTaskReset")}
                        style={{ marginLeft: 10 }}
                        color="secondary"
                        disabled={loading}  // Disable buttons when loading
                    >
                        {t("col.Reset")}
                    </CustButton>
                </>
            }


        >
            <DownloadButton service={taskDataList} disabled={loading} />
        </ListPageActions>;
    }

    const WorkMointorButtons = () => {
        return <ListPageActions
            left={
                <>
                    <MenuAction menuItems={
                        [
                            {
                                label: t('col.Set'),
                                icon: <AddTask fontSize="small" style={{ color: '#DDD4FF' }} />,
                                action: () => {
                                    openConfirmDialog("WorkerMonitorSet");
                                }
                            },
                            {
                                label: t('col.Reset'),
                                icon: <RestartAlt fontSize="small" style={{ color: 'secondary' }} />,
                                action: () => {
                                    openConfirmDialog("WorkerMonitorReset");
                                }
                            },
                            {
                                label: t('col.SetAll'),
                                icon: <AddTask fontSize="small" style={{ color: '#DDD4FF' }} />,
                                action: () => {
                                    openConfirmDialog("WorkerMonitorSetAll");
                                }
                            },
                            {
                                label: t('col.ResetAll'),
                                icon: <AddTask fontSize="small" style={{ color: 'secondary' }} />,
                                action: () => {
                                    openConfirmDialog("WorkerMonitorResetAll");
                                }
                            },
                        ]
                    } />

                </>
            }

        >
            <DownloadButton service={mointorDataList} disabled={loading} />
        </ListPageActions>;
    }

    const WorkListButtons = () => {
        return <ListPageActions
            left={
                <>
                    <CustButton
                        icon={RestartAlt}
                        onClick={() => openConfirmDialog("WorkerReset")}
                        style={{ marginLeft: 10 }}
                        color="secondary"
                        disabled={loading}  // Disable buttons when loading
                    >
                        {t("col.Reset")}
                    </CustButton>
                </>
            }


        >
            <DownloadButton service={workerDataList} disabled={loading} />
        </ListPageActions>;
    }

    const [selectedTab, setSelectedTab] = useState(0);

    // Handle Tab change
    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
        if (newValue == 0) {
            mainDataList.setSearchData({ isMaster: user.isMaster });
            // setAutoReset(false);
        }
    };

    return (
        <Page title={title}>


            <Box sx={{ bgcolor: 'background.paper' }}>
                <Tabs
                    value={selectedTab}
                    onChange={handleTabChange}
                    aria-label="tab menu"
                    centered
                    indicatorColor="primary" // Color for the active tab indicator
                >
                    <Tab key={0} label={t('col.WorkerPlannedJob')} />
                    <Tab key={1} label={t('col.workerTask')} />
                    <Tab key={2} label={t('col.workerList')} />
                    <Tab key={3} label={t('col.taskSummary')} />
                </Tabs>
            </Box>

            < WorkerPlannedJobCrudDialog
                open={onCrudDialogOpen}
                onClose={() => handleClose()}
                data={jobId}
                crudTip={crudTip}
                title={title}
            />


            {selectedTab == 0 &&
                <>
                    <ActionButtons />
                    <Box sx={{ flexGrow: 1, mt: 2 }}>
                        <DataTable
                            key="job"
                            selectAll
                            setSelected={setSelectedItems}
                            selected={selectedItems}
                            title={t('col.WorkerPlannedJob')}
                            columns={columns}
                            {...mainDataList}
                            loading={loading}
                        />
                    </Box>
                </>

            }

            {selectedTab == 1 &&
                <Box sx={{ flexGrow: 1, mt: 2 }}>
                    <Grid container spacing={2}>

                        <Grid item xs={12} md={6}>
                            <WorkTaskButtons />
                            <DataTable
                                key="task"
                                selectAll
                                setSelected={SetWorkerTasks}
                                selected={wokrerTasks}
                                title={t('col.workerTask')}
                                columns={taskColumns}
                                {...taskDataList}
                                loading={loading}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <WorkMointorButtons />
                            <DataTable
                                key="montior"
                                selectAll
                                setSelected={SetWorkerMonitors}
                                selected={wokrerMonitors}
                                title={t('col.WorkerMonitor')}
                                columns={monitorColumn}
                                {...mointorDataList}
                                loading={loading}
                            />
                        </Grid>
                    </Grid>
                </Box>}

            {selectedTab == 2 &&
                <>
                    <WorkListButtons />
                    <Box sx={{ flexGrow: 1, mt: 2 }}>
                        <DataTable
                            key="workerTab"
                            title={t('col.workerList')}
                            selectAll
                            setSelected={SetWorkers}
                            selected={wokrers}
                            columns={workerColumn}
                            {...workerDataList}
                            loading={loading} />
                    </Box>
                </>
            }

            {selectedTab == 3 &&
                <Box sx={{ flexGrow: 1, mt: 2 }}>
                    <DataTable
                        key="wokrersummary"
                        title={t('col.taskSummary')}
                        columns={workerSummaryColumn}
                        {...workerSummaryDataList}
                        loading={loading} />
                </Box>
            }


            <DialogConfirm
                open={openDialog}
                title={t('title.confirmDialogTitle')}
                content={t('message.areYouSureAction')}
                onClose={closeConfirmDialog}
                onConfirm={handleAction}
                loading={loading}  //  Disable confirm button when loading
            />
        </Page>
    );
};
export default WorkerPlannedJobPage;